/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
class Discovery {
  key = 'discoveryUrl';

  _get() {
    const data = sessionStorage.getItem(this.key);
    return data ? JSON.parse(data) : {};
  }

  clear() {
    sessionStorage.removeItem(this.key);
  }

  delete(appId) {
    const data = this._get();
    delete data[appId];
    Object.keys(data).length || this.clear();
    sessionStorage.setItem(this.key, JSON.stringify(data));
  }

  get(appId) {
    return this._get()[appId];
  }

  set(appId, value) {
    const data = this._get();
    data[appId] = value;
    sessionStorage.setItem(this.key, JSON.stringify(data));
  }
}

export default new Discovery;
